<template>
  <div class="register">
    <div :class="`step_head ${registre_step == 2 ? 'step_head_2' : ''}`">
      <div v-for="i in 3" :key="i" :class="`step_head_item ${i <= registre_step ? 'active' : ''}`"></div>
    </div>

    <!-- Step 1 -->
    <div :class="`step step_1 ${registre_step == 1 ? 'active' : ''}`">
      <div class="title">{{ text('auth.register.title') }}</div>
      <div class="inputs">
        <Input type="text" v-model:value="user.first_name" :placeholder="text('auth.register.first_name')"/>
        <Input type="text" v-model:value="user.last_name" :placeholder="text('auth.register.last_name')"/>
        <Input type="email" v-model:value="user.email" :placeholder="text('auth.register.email')"/>

        <InputMask v-model:phone="user.phone"/>

        <template v-if="envName === 'grok'">
          <div class="section-divider">
            <h3>{{ text('auth.register.address_section') }}</h3>
          </div>

          <SelectCountry v-model="user.country_code"/>
          <div class="input-row">
            <Input type="text" v-model:value="user.city" :placeholder="text('auth.register.city')"/>
            <Input type="text" v-model:value="user.zip_code" :placeholder="text('auth.register.zip_code')"/>
          </div>
          <Input type="text" v-model:value="user.address" :placeholder="text('auth.register.address')"/>
        </template>
      </div>

      <YandexCaptcha
        ref="yandexCaptchaRef"
        @token-received="onCaptchaTokenReceived"
        @token-expired="onCaptchaTokenExpired"
      />

      <template v-if="envName === 'grok'">
        <BaseButton
          @click="register"
          :disabled="!ofertaAccepted || !persDataAccepted || user.first_name.length === 0 || user.last_name === 0 || !isEmailValid(user.email) || user.country_code.length === 0 || user.city.length === 0 || user.zip_code.length === 0 || user.address.length === 0 || (yandexCaptchaEnabled && !captchaToken)"
        >
          <template #label>
            {{ text('auth.register.continue_btn') }}
          </template>
        </BaseButton>
      </template>
      <template v-else>
        <BaseButton
          @click="register"
          :disabled="!ofertaAccepted || !persDataAccepted || user.first_name.length === 0 || user.last_name === 0 || !isEmailValid(user.email) || (yandexCaptchaEnabled && !captchaToken)"
        >
          <template #label>
            {{ text('auth.register.continue_btn') }}
          </template>
        </BaseButton>
      </template>

      <div class="error">{{ errorMessage }}</div>

      <div class="text">
        <router-link :to="{name: 'LogIn'}">
          {{ text('auth.register.enter_help') }}
        </router-link>
      </div>
      <br/>
      <br/>

      <StaterAccept
        v-if="envName === 'stater'"
        v-model:ofertaAccepted="ofertaAccepted"
        v-model:persDataAccepted="persDataAccepted"
      />
    </div>
    <!-- End step 1 -->

    <!-- Step 2 -->
    <div :class="`step step_2 ${registre_step == 2 ? 'active' : ''}`">
      <AuthIdentification
        v-model:confirmCode="confirmCode"
        :phone="user.phone"
        @onPrevPage="changeToPrevPage"
        :title="text('auth.register.enter_code_help')"
        :description="text('auth.register.enter_code_descr')"
      />
      <div class="error">{{ errorMessage }}</div>

      <div style="margin: 0 24px;" class="text" v-if="envName === 'stater'">
        Не приходит код? <br/>
        Обратитесь в службу поддержки: <br/>
        <br/>
        <b>+7 (940) 999-11-33</b>
      </div>

      <BaseButton
        @click="phoneConfirm"
        :disabled="confirmCode.length < 4"
        style="margin: 24px 0"
      >
        <template #label>
          {{ text('auth.register.continue_btn') }}
        </template>
      </BaseButton>
      <send-again-button
        @click="sendCode()"
        :title="text('auth.register.send_again_btn')"
      />

    </div>
    <!-- End step 2 -->

    <!-- Step 3 -->
    <div :class="`step step_3 ${registre_step == 3 ? 'active' : ''}`">
      <AuthIdentification
        v-model:confirmCode="pinCode"
        :prevButton="false"
        :title="text('auth.register.set_pin.help')"
        :description="text('auth.register.set_pin.descr')"
      />
      <BaseButton
        @click="savePinCode"
        :disabled="pinCode.length < 4"
        style="margin: 24px 0"
      >
        <template #label>
          {{ text('auth.register.set_pin.continue') }}
        </template>
      </BaseButton>
    </div>
    <!-- End step 3 -->

    <GrokPolicy v-if="envName === 'grok'"/>

  </div>
</template>

<script>

import Input from "@/components/Input.vue"
import InputMask from "@/components/phone_input/InputMask.vue"
import BaseButton from '@/components/base/buttons/BaseButton.vue'
import AuthIdentification from '@/components/AuthIdentification.vue'
import SendAgainButton from '@/components/SendAgainButton.vue'
import {doRegister, doRegisterPhoneConfirm, doRegisterSetPin} from "@/services/api"
import StaterAccept from '@/components/StaterAccept.vue'
import GrokPolicy from '@/components/GrokPolicy.vue'
import SelectCountry from '@/components/SelectCountry.vue'
import YandexCaptcha from '@/components/YandexCaptcha.vue'
import { isEmailValid } from '@/utils/validation.js'

export default {
  name: "Register",
  components: {
    Input,
    InputMask,
    BaseButton,
    AuthIdentification,
    SendAgainButton,
    StaterAccept,
    GrokPolicy,
    SelectCountry,
    YandexCaptcha
  },
  computed: {
    authToken() {
      return this.$store.state.authToken
    }
  },
  data() {
    return {
      registre_step: 1,
      user: {
        first_name: '',
        last_name: '',
        email: '',
        address: '',
        city: '',
        country_code: '',
        zip_code: '',
        phone: ''
      },
      confirmCode: '',
      pinCode: '',
      errorMessage: '',
      ofertaAccepted: true,
      persDataAccepted: true,
      captchaToken: ''
    }
  },
  methods: {
    isEmailValid,
    async sendCode() {
      const requestData = {"phone": this.user.phone}

      // Добавляем токен капчи если он доступен
      if (this.yandexCaptchaEnabled && this.captchaToken) {
        requestData.captcha_token = this.captchaToken
      }

      const {data} = await this.$http.post(
        '/v2/wallet/auth/send_code',
        requestData,
        {
          validateStatus: (status) => (status >= 200 && status < 500)
        }
      )
    },
    async register() {
      this.pinCode = ''

      let resp
      let registerData

      if (this.envName === 'grok') {
        registerData = {
          "first_name": this.user.first_name,
          "last_name": this.user.last_name,
          "phone": this.user.phone,
          "email": this.user.email,
          "country_code": this.user.country_code,
          "city": this.user.city,
          "zip_code": this.user.zip_code,
          "address": this.user.address
        }
      } else {
        registerData = {
          "first_name": this.user.first_name,
          "last_name": this.user.last_name,
          "phone": this.user.phone,
          "email": this.user.email
        }
      }   
      registerData.space_iname = this.envName

      // Добавляем токен капчи если он доступен
      if (this.yandexCaptchaEnabled && this.captchaToken) {
        registerData.captcha_token = this.captchaToken
      }

      resp = await doRegister(registerData)
      if (resp.status === "error") {
        this.errorMessage = resp.message
        // Сбрасываем состояние капчи при ошибке
        if (this.yandexCaptchaEnabled && this.$refs.yandexCaptchaRef) {
          this.$refs.yandexCaptchaRef.reset()
          this.captchaToken = ''
        }
      } else {
        this.errorMessage = ''
        this.registre_step = 2
      }
    },
    async savePinCode() {
      await doRegisterSetPin(this.authToken, this.pinCode)
      this.$router.push('/')
    },
    changeToPrevPage() {
      this.registre_step = 1
    },
    async phoneConfirm() {
      const resp = await doRegisterPhoneConfirm(this.user.phone, this.confirmCode)
      if (resp.status === "error") {
        this.errorMessage = resp.message
      } else {
        this.errorMessage = ''
        this.$store.commit('setAuthToken', resp.auth_token)
        this.registre_step = 3
      }
    },
    onCaptchaTokenReceived(token) {
      this.captchaToken = token
      console.log('Captcha token received in Register:', token)
    },
    onCaptchaTokenExpired() {
      this.captchaToken = ''
      this.errorMessage = 'Время действия капчи истекло. Пожалуйста, пройдите проверку заново.'
    }
  }
}
</script>